export const CheckedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="10"
    fill="none"
    viewBox="0 0 13 10"
  >
    <path
      fill="#fff"
      d="M4.197 10 0 5.806l1.203-1.202 2.994 2.992L11.797 0 13 1.202z"
    ></path>
  </svg>
);

export const UploadCloudIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="40"
    fill="none"
    viewBox="0 0 56 40"
  >
    <path
      fill="#9E9E9E"
      d="M13.333 40q-5.528 0-9.43-3.835T0 26.79q0-4.97 3.197-8.741t7.931-4.47Q12.411 7.6 17.141 3.8 21.872 0 28 0q7.242 0 12.288 5.045 5.046 5.046 5.045 12.288v1.334h.821q4.216.327 7.03 3.39 2.817 3.06 2.816 7.276 0 4.462-3.077 7.564T45.385 40H30.82Q28.8 40 27.4 38.6T26 35.18V20.573l-4.933 4.851-2.81-2.784L28 12.897l9.743 9.744-2.81 2.784L30 20.574v14.605q0 .309.257.564.255.257.564.257h14.512q2.8 0 4.734-1.933Q52 32.133 52 29.333T50.067 24.6t-4.734-1.933h-4v-5.334q0-5.533-3.9-9.433T28 4t-9.433 3.9-3.9 9.433h-1.385q-3.79 0-6.536 2.734T4 26.667q0 3.865 2.733 6.6Q9.467 36 13.333 36H20v4z"
    ></path>
  </svg>
);

export const CompositionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    fill="none"
    viewBox="0 0 19 19"
  >
    <path
      fill="#239DCE"
      d="m4.447 0 4.447 2.628v5.255l-4.447 2.628L0 7.883V2.628zM14.149 0l4.447 2.628v5.255l-4.447 2.628-4.447-2.628V2.628zM9.298 8.49l4.447 2.628v5.255l-4.447 2.628-4.447-2.628v-5.255z"
    ></path>
  </svg>
);

export const DragThumbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="6"
    fill="none"
    viewBox="0 0 16 6"
  >
    <path fill="#4D4D4D" d="M0 6V4.364h16V6zm0-4.364V0h16v1.636z"></path>
  </svg>
);

export const TrashCanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14"
    fill="none"
    viewBox="0 0 13 14"
  >
    <path
      fill="#F44336"
      d="M4.247 10.396 6.5 8.24l2.253 2.156.914-.873-2.254-2.156L9.667 5.21l-.914-.874L6.5 6.493 4.247 4.337l-.914.874 2.254 2.156-2.254 2.156zM.867 14V1.977H0V.733h3.9V0h5.2v.733H13v1.244h-.867V14zm1.3-1.244h8.666V1.977H2.167z"
    ></path>
  </svg>
);

export const ClearIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="8"
    fill="none"
    viewBox="0 0 16 8"
  >
    <path
      fill={color ? color : "#4D4D4D"}
      d="M.914 7.7V6.45h10.938V7.7zm1.61-3.076v-1.25h10.938v1.25zm1.62-3.077V.297H15.08v1.25z"
    ></path>
  </svg>
);

export const PlusIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
  >
    <path
      fill={color ? color : "#239DCE"}
      d="M5.375 6.626H.583v-1.25h4.792V.584h1.25v4.792h4.792v1.25H6.625v4.791h-1.25z"
    ></path>
  </svg>
);

export const ArrowRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    fill="none"
    viewBox="0 0 14 10"
  >
    <path
      fill="#fff"
      d="m8.539 9.712-.879-.904 3.183-3.182H.75v-1.25h10.093L7.66 1.193 8.54.289l4.711 4.712z"
    ></path>
  </svg>
);

export const CancelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="9"
    fill="none"
    viewBox="0 0 10 9"
  >
    <path
      fill="#F44336"
      d="M1.442 9 5 5.798 8.558 9 10 7.702 6.442 4.5 10 1.298 8.558 0 5 3.202 1.442 0 0 1.298 3.558 4.5 0 7.702z"
    ></path>
  </svg>
);

export const EditIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#239DCE"
      d="M8.004 15.92a7.7 7.7 0 0 1-3.088-.624 8 8 0 0 1-2.514-1.692A8 8 0 0 1 .71 11.091a7.7 7.7 0 0 1-.623-3.087q0-1.642.623-3.088a8 8 0 0 1 1.692-2.514A8 8 0 0 1 4.914.71 7.7 7.7 0 0 1 8.001.086q1.642 0 3.088.623 1.444.624 2.514 1.692a8 8 0 0 1 1.693 2.513q.623 1.445.623 3.087a7.7 7.7 0 0 1-.623 3.088 8 8 0 0 1-1.692 2.514 8 8 0 0 1-2.513 1.693 7.7 7.7 0 0 1-3.087.623m-.001-1.25q2.79 0 4.729-1.938 1.937-1.937 1.937-4.73 0-2.79-1.937-4.729-1.937-1.937-4.73-1.937-2.79 0-4.729 1.937-1.937 1.937-1.937 4.73 0 2.79 1.937 4.729 1.937 1.937 4.73 1.937m-3.077-3.59V8.878l5.222-5.202 2.194 2.189-5.214 5.214zm.993-.994h.792l2.705-2.718-.375-.404-.396-.383L5.92 9.294zm3.122-3.122-.396-.383.771.787z"
    ></path>
  </svg>
);

export const DoubleCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="8"
    fill="none"
    viewBox="0 0 16 8"
  >
    <path
      fill="#fff"
      d="M4.466 7.767.93 4.232l.713-.703 2.833 2.833.23-.23.703.702zm3.766 0L4.696 4.232l.703-.713 2.833 2.833L14.366.22l.702.713zm-.23-3.535-.713-.703 3.3-3.3.712.703z"
    ></path>
  </svg>
);

export const CheckedSmallIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="7"
    fill="none"
    viewBox="0 0 8 7"
  >
    <path
      fill="#fff"
      d="m2.664 6.699-2.43-2.43.697-.696 1.733 1.733 4.4-4.4.696.696z"
    ></path>
  </svg>
);

export const CancelSmallIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="7"
    fill="none"
    viewBox="0 0 7 7"
  >
    <path stroke="#fff" d="M6 1 1 6M1 1l5 5"></path>
  </svg>
);

export const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="8"
    fill="none"
    viewBox="0 0 6 8"
  >
    <path
      fill="#239DCE"
      d="M3.63 4.004.562.937l.702-.703 3.77 3.77-3.77 3.769-.702-.703z"
    ></path>
  </svg>
);

export const DoubleRightArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="8"
    fill="none"
    viewBox="0 0 10 8"
  >
    <path
      fill="#239DCE"
      d="M4.033 4.004.977.937l.702-.703 3.77 3.77-3.77 3.769-.702-.703zm4.233 0L5.21.937l.702-.703 3.77 3.77-3.77 3.769-.702-.703z"
    ></path>
  </svg>
);

export const ArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="8"
    fill="none"
    viewBox="0 0 6 8"
  >
    <path
      fill="#239DCE"
      d="M1.968 4.004 5.034.937 4.332.234l-3.77 3.77 3.77 3.769.702-.703z"
    ></path>
  </svg>
);

export const DoubleLeftArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="8"
    fill="none"
    viewBox="0 0 10 8"
  >
    <path
      fill="#239DCE"
      d="m4.082 7.773-3.77-3.77L4.082.235l.702.703-3.056 3.067L4.784 7.07zm4.233 0-3.77-3.77L8.316.235l.703.703L5.96 4.004 9.018 7.07z"
    ></path>
  </svg>
);

export const DescIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="17"
    fill="none"
    viewBox="0 0 20 17"
  >
    <path
      fill={color ? color : "#9E9E9E"}
      d="M17 0v12h3l-4 5-4-5h3V0zM9 14v2H0v-2zm2-7v2H0V7zm0-7v2H0V0z"
    ></path>
  </svg>
);